var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import qs from 'qs';
import { Box, Grid, Typography } from '@mui/material';
import { offerList as api } from '../../api';
import { useOrderColumns } from '../../hooks/useColumns';
import { useFetchOrders } from '../../hooks/useOrder';
import { useRequest } from '../../hooks/requestHook';
import PageLayout from '../atoms/PageLayout';
import MaterialTable from '../MaterialTable';
import AdminNewOrderButton from '../organisms/AdminNewOrderButton';
import PaymentTimingFilter from '../molecules/PaymentTimingFilter';
var AdminOfferListOrdersPage = function () {
    var _a = useParams(), _b = _a.id, id = _b === void 0 ? '' : _b, _c = _a.warehouseId, warehouseId = _c === void 0 ? '' : _c;
    var location = useLocation();
    var t = useTranslation().t;
    var _d = React.useState(), offerList = _d[0], setOfferList = _d[1];
    var getOfferList = useRequest(api.get);
    var fetchOrders = useFetchOrders({
        offer_list_id_eq: id,
        in_offer_list_and_warehouse: [id, warehouseId],
        type_eq: 'Order::DirectOrder',
    });
    var query = qs.parse(location.search.slice(1));
    var OrderColumns = useOrderColumns({
        role: 'admin',
        filters: query.filters,
        orderBy: query.orderBy,
        orderDirection: query.orderDirection,
    });
    var renderPaymentTimingFilter = React.useCallback(function (props) { return React.createElement(PaymentTimingFilter, __assign({}, props)); }, []);
    var columns = React.useMemo(function () { return [
        OrderColumns.roasterName,
        OrderColumns.billingName,
        OrderColumns.storeName,
        OrderColumns.personName,
        OrderColumns.email,
        __assign(__assign({}, OrderColumns.paymentTiming), { title: t('labels.paymentTimingOnAdmin'), filterComponent: renderPaymentTimingFilter }),
        OrderColumns.status,
        OrderColumns.createdAt,
    ]; }, [t, OrderColumns, renderPaymentTimingFilter]);
    React.useEffect(function () {
        var canceled = false;
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getOfferList({
                            id: id,
                            with_transport_to_warehouses: true,
                        })];
                    case 1:
                        response = _a.sent();
                        if (canceled)
                            return [2 /*return*/];
                        if (!response)
                            return [2 /*return*/];
                        setOfferList(response);
                        return [2 /*return*/];
                }
            });
        }); })();
        return function () {
            canceled = true;
        };
    }, [id, getOfferList]);
    var warehouseName = React.useMemo(function () {
        var _a;
        if (!offerList || !offerList.transportToWarehouses)
            return '';
        var warehouse = (_a = offerList.transportToWarehouses.find(function (_a) {
            var warehouse = _a.warehouse;
            return warehouse.id === warehouseId;
        })) === null || _a === void 0 ? void 0 : _a.warehouse;
        return (warehouse === null || warehouse === void 0 ? void 0 : warehouse.name) || '';
    }, [offerList, warehouseId]);
    return (React.createElement(PageLayout, { backLinkTo: "/admin/offer_lists/".concat(id, "/warehouses"), title: t('pages.ordersPage.title'), actions: React.createElement(AdminNewOrderButton, { offerList: offerList }) },
        React.createElement(Box, { px: 1, py: 2 }, offerList && (React.createElement(Grid, { container: true },
            React.createElement(Grid, { item: true, xs: 12, sm: 3 },
                React.createElement(Typography, { variant: "subtitle1" },
                    t('params.offerList.name'),
                    ":")),
            React.createElement(Grid, { item: true, xs: 12, sm: 9 },
                React.createElement(Typography, { variant: "body2" }, offerList.name)),
            React.createElement(Grid, { item: true, xs: 12, sm: 3 },
                React.createElement(Typography, { variant: "subtitle1" },
                    t('labels.curatorName'),
                    ":")),
            React.createElement(Grid, { item: true, xs: 12, sm: 9 },
                React.createElement(Typography, { variant: "body2" }, "".concat(offerList.producer.firstname, " ").concat(offerList.producer.lastname, " (").concat(t("countries.".concat(offerList.producer.country)), ")"))),
            React.createElement(Grid, { item: true, xs: 12, sm: 3 },
                React.createElement(Typography, { variant: "subtitle1" },
                    t('params.warehouse.name'),
                    ":")),
            React.createElement(Grid, { item: true, xs: 12, sm: 9 },
                React.createElement(Typography, { variant: "body2" }, warehouseName))))),
        React.createElement(MaterialTable, { model: "order", columns: columns, data: fetchOrders, options: {
                initialPage: parseInt(query.page) || 0,
                pageSize: parseInt(query.pageSize) || 25,
                paging: true,
                filtering: true,
            }, detailPath: function (order) { return "/admin/orders/".concat(order.id); } })));
};
export default AdminOfferListOrdersPage;
